import { JobApplication } from "../../../Entities/JobApplication";
import dayjs from "dayjs";

export const isProfileMatchCompleted = (jobApplication: JobApplication) => {
  if (jobApplication?.profileId && jobApplication?.profileMatchStatus) {
    return true;
  } else {
    return false;
  }
};

export const isQuestionnaireCompleted = (jobApplication: JobApplication) => {
  if (
    jobApplication?.questionnaireStatus &&
    jobApplication?.questionnaireStatus !== "pending"
  ) {
    return true;
  } else {
    return false;
  }
};

export const isQuestionnairePending = (jobApplication: JobApplication) => {
  if (
    jobApplication?.questionnaireStatus &&
    jobApplication?.questionnaireStatus === "pending"
  ) {
    return true;
  } else {
    return false;
  }
};

export const isInterviewSlotSelectionPending = (
  jobApplication: JobApplication
) => {
  if (
    jobApplication?.status === "interview" &&
    !jobApplication?.interviewSchedule
  ) {
    return true;
  } else {
    return false;
  }
};

export const isInterviewSlotBooked = (jobApplication: JobApplication) => {
  if (jobApplication?.interviewSchedule) {
    return true;
  } else {
    return false;
  }
};

export const isShortlisted = (jobApplication: JobApplication) => {
  if (jobApplication?.status === "shortlisted") {
    return true;
  } else {
    return false;
  }
};

export const isHired = (jobApplication: JobApplication) => {
  if (jobApplication?.status === "hired") {
    return true;
  } else {
    return false;
  }
};

export const getCurrentApplicationStatusMessage = (
  jobApplication: JobApplication
) => {
  const profileMatchCompleted = isProfileMatchCompleted(jobApplication);
  const questionnaireCompleted = isQuestionnaireCompleted(jobApplication);
  const questionnairePending = isQuestionnairePending(jobApplication);
  const interviewSlotSelectionPending =
    isInterviewSlotSelectionPending(jobApplication);
  const interviewSlotBooked = isInterviewSlotBooked(jobApplication);
  const hired = isHired(jobApplication);
  const shortlisted = isShortlisted(jobApplication);

  let message = "";

  if (hired) {
    message = `This application was marked as hired on ${dayjs(
      jobApplication.updatedAt
    ).format("DD MMM YYYY")}`;
  } else if (shortlisted) {
    message = `This application was marked as shortlisted`;
  } else if (interviewSlotBooked) {
    message = `An online interview with the hiring team is scheduled on ${dayjs(
      jobApplication.interviewSchedule
    ).format("DD MMM YYYY")}`;
  } else if (!profileMatchCompleted) {
    message = "Resume Not Uploaded";
  } else if (questionnairePending) {
    message = "Waiting for AI Assessment round completion";
  } else if (interviewSlotSelectionPending) {
    message = "Waiting for Interview Slot Selection";
  } else if (questionnaireCompleted) {
    message = "Questionnaire Completed";
  } else if (profileMatchCompleted) {
    message = "Profile Match Completed";
  } else {
    message = "Unknown Status";
  }

  return message;
};
